// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ProgressContract = contract({
  name: "Progress",
  description: "Determinate progress — file uploads, multi-step forms, quota meters. Indeterminate state → use Skeleton or animated Loader icon.",
  import: "@gradeui/ui",
  aliases: ["progress","progress view","progress indicator","progress bar","determinate progress","loading bar","completion bar"],
  element: "div",
  composesWith: ["Card (as a section)","Badge (showing % next to it)","Label (describing what's loading)"],
  styleDefaults: {"Progress":"relative h-4 w-full overflow-hidden rounded-full bg-secondary"},
  props: {
  "value": {
      schema: z.number().optional(),
      design: "knob",
      description: "percent complete",
  },
  "max": {
      schema: z.number().optional(),
      design: "knob",
  },
  "tone": {
      schema: z.enum(["primary", "accent", "muted"]).optional(),
      design: "knob",
      description: "fill colour of the bar (default \"primary\"). Reach for \"accent\" when the bar is LARGE, a full-width wizard header bar in the action colour reads as competing with the page's actual actions rather than as progress. \"muted\" for a purely informational gauge (quota, storage) where brand colour over-signals. Use this prop; do NOT tint the indicator with a child selector from outside.",
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
  },
  },
});
